import { render, staticRenderFns } from "./addHandle.vue?vue&type=template&id=d5e37f10&scoped=true"
import script from "./addHandle.vue?vue&type=script&lang=js"
export * from "./addHandle.vue?vue&type=script&lang=js"
import style0 from "./addHandle.vue?vue&type=style&index=0&id=d5e37f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e37f10",
  null
  
)

export default component.exports